import React from "react";
import i18n from "../../i18n";

export class PartnersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      isTransitioning: false,
      hoveredPartner: null,
      itemsPerSlide: this.getItemsPerSlide(), // responsive setup
    };

    this.partners = [
      { id: 1, name: "", logo: "/assets/images/partners/partner-01.png",  },
      { id: 2, name: "", logo: "/assets/images/partners/partner-02.png"},
      { id: 3, name: "", logo: "/assets/images/partners/partner-03.png"},
      { id: 4, name: "", logo: "/assets/images/partners/partner-04.png" },
      { id: 5, name: "", logo: "/assets/images/partners/partner-05.png" },
      { id: 6, name: "", logo: "/assets/images/partners/partner-06.png" },
      { id: 7, name: "", logo: "/assets/images/partners/partner-07.png"},
      { id: 8, name: "", logo: "/assets/images/partners/partner-08.png"},
      { id: 9, name: "", logo: "/assets/images/partners/partner-09.png" },
      { id: 10, name: "", logo: "/assets/images/partners/partner-10.png" },
      { id: 11, name: "", logo: "/assets/images/partners/partner-11.png" },
      { id: 12, name: "", logo: "/assets/images/partners/partner-12.png"},
    ];
  }

  // 🔹 Responsive items count
  getItemsPerSlide = () => {
    if (window.innerWidth < 576) return 2; // Mobile
    if (window.innerWidth < 992) return 4; // Tablet
    return 6; // Desktop
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    // Update on resize
    window.addEventListener("resize", this.handleResize);

    // Auto-slide
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 4000);
  }

  componentWillUnmount() {
    if (this.slideInterval) clearInterval(this.slideInterval);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ itemsPerSlide: this.getItemsPerSlide(), currentIndex: 0 });
  };

  nextSlide = () => {
    if (this.state.isTransitioning) return;

    const { currentIndex, itemsPerSlide } = this.state;
    const maxIndex = Math.max(0, this.partners.length - itemsPerSlide);

    this.setState({ isTransitioning: true });
    setTimeout(() => {
      this.setState({
        currentIndex: currentIndex >= maxIndex ? 0 : currentIndex + 1,
        isTransitioning: false,
      });
    }, 300);
  };

  prevSlide = () => {
    if (this.state.isTransitioning) return;

    const { currentIndex, itemsPerSlide } = this.state;
    const maxIndex = Math.max(0, this.partners.length - itemsPerSlide);

    this.setState({ isTransitioning: true });
    setTimeout(() => {
      this.setState({
        currentIndex: currentIndex <= 0 ? maxIndex : currentIndex - 1,
        isTransitioning: false,
      });
    }, 300);
  };

  handlePartnerHover = (partnerId) => {
    this.setState({ hoveredPartner: partnerId });
  };

  handlePartnerLeave = () => {
    this.setState({ hoveredPartner: null });
  };

  render() {
    const { currentIndex, isTransitioning, hoveredPartner, itemsPerSlide } = this.state;
    const maxIndex = Math.max(0, this.partners.length - itemsPerSlide);
    const visiblePartners = this.partners.slice(currentIndex, currentIndex + itemsPerSlide);

    // Fill slide if needed
    while (visiblePartners.length < itemsPerSlide && this.partners.length >= itemsPerSlide) {
      visiblePartners.push(...this.partners.slice(0, itemsPerSlide - visiblePartners.length));
    }

    return (
      <section className="partners-section py-5 bg-light" id="partners">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="display-6 fw-bold text-dark mb-3">{i18n.t("our_partners")}</h2>
              <p className="lead text-muted mb-0 mx-auto" style={{ maxWidth: "600px" }}>
              </p>
            </div>
          </div>

          <div className="position-relative overflow-hidden">
            <div
              className={`d-flex align-items-center transition-opacity ${
                isTransitioning ? "opacity-75" : ""
              }`}
              style={{
                transition: isTransitioning ? "opacity 0.3s ease" : "none",
                minHeight: "120px",
              }}
            >
              {visiblePartners.map((partner, index) => (
                <div
                  key={`${partner.id}-${currentIndex}-${index}`}
                  className="flex-shrink-0 px-2 px-md-3"
                  style={{ width: `${100 / itemsPerSlide}%` }} // 🔹 dynamic width
                >
                  <div
                    className="partner-card bg-white rounded-3 shadow-sm border-0 p-3 p-md-4 h-100 d-flex align-items-center justify-content-center position-relative overflow-hidden"
                    style={{
                      minHeight: "100px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      transform: hoveredPartner === partner.id ? "translateY(-5px)" : "translateY(0)",
                      boxShadow:
                        hoveredPartner === partner.id
                          ? "0 8px 25px rgba(0,0,0,0.15)"
                          : "0 2px 10px rgba(0,0,0,0.08)",
                    }}
                    onMouseEnter={() => this.handlePartnerHover(partner.id)}
                    onMouseLeave={this.handlePartnerLeave}
                  >
                    <img
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      className="img-fluid"
                      style={{
                        maxHeight: "110px",
                        maxWidth: "100px",
                        objectFit: "contain",
                        filter:
                          hoveredPartner === partner.id
                            ? "grayscale(0%) brightness(1)"
                            : "grayscale(100%) brightness(0.7)",
                        transition: "all 0.4s ease",
                        transform: hoveredPartner === partner.id ? "scale(1.05)" : "scale(1)",
                        opacity: hoveredPartner === partner.id ? 1 : 0.8,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Arrows only on desktop */}
            {this.partners.length > itemsPerSlide && (
              <>
                <button
                  className="btn btn-light rounded-circle position-absolute top-50 start-0 translate-middle-y shadow-sm d-none d-lg-flex"
                  onClick={this.prevSlide}
                  style={{ width: "40px", height: "40px", marginLeft: "-20px", zIndex: 10 }}
                  disabled={isTransitioning}
                >
                  <i className="fas fa-chevron-left text-muted"></i>
                </button>

                <button
                  className="btn btn-light rounded-circle position-absolute top-50 end-0 translate-middle-y shadow-sm d-none d-lg-flex"
                  onClick={this.nextSlide}
                  style={{ width: "40px", height: "40px", marginRight: "-20px", zIndex: 10 }}
                  disabled={isTransitioning}
                >
                  <i className="fas fa-chevron-right text-muted"></i>
                </button>
              </>
            )}
          </div>

          {/* Dots */}
          {/* {this.partners.length > itemsPerSlide && (
            <div className="text-center mt-4">
              <div className="d-inline-flex gap-2">
                {Array.from({ length: maxIndex + 1 }, (_, index) => (
                  <button
                    key={index}
                    className={`btn rounded-circle p-0 border-0 ${
                      index === currentIndex ? "bg-primary" : "bg-secondary"
                    }`}
                    onClick={() => !isTransitioning && this.setState({ currentIndex: index })}
                    style={{
                      width: "8px",
                      height: "8px",
                      opacity: index === currentIndex ? 1 : 0.4,
                      transition: "all 0.3s ease",
                    }}
                    disabled={isTransitioning}
                  ></button>
                ))}
              </div>
            </div>
          )} */}
        </div>
      </section>
    );
  }
}
